/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { CustomerModel, CustomersFetchModel } from '../../../domain/models'
import { fetchListAll, fetchMe, filterCustomer } from '../../../main/usecases'

import { maskCpf, goToUrl } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import {
  Button,
  Table,
  EmptyData,
  InputFilter,
  NewRegisterForm
} from '../../components'

import {
  PlusSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'
import DeleteCustomerModal from './delete-customer'

export type FilterCustomerValuesProps = {
  name: string
  cpf: string
}

type PageProps = {
  setRunTuto?: (e: any) => void
}

const MyClients = ({ setRunTuto }: PageProps) => {
  const [customers, setCustomers] = useState<CustomersFetchModel>()
  const [filterCustomerValues, setFilterCustomerValues] =
    useState<FilterCustomerValuesProps>()
  const [page, setPage] = useState(1)
  const history = useHistory()
  const { modalBox } = useModalBox()
  const alert = useAlert()
  const { refresh } = useOnChangeDetect()

  const handleClickNewClientRegister = () => {
    modalBox(<NewRegisterForm />, 'Cadastro de novo paciente', '40%')
  }

  const handleRedirectToRegistrationData = (row: any) => {
    return goToUrl(history, `/meus-pacientes/${row?.original?.code}/prontuario`)
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Código',
        accessor: 'code'
      },
      {
        Header: 'Nome',
        accessor: 'name'
      },
      {
        Header: 'CPF',
        accessor: 'cpf'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )

  const data = useMemo(() => {
    const handleOpenDeleteModal = (id: number) => {
      modalBox(<DeleteCustomerModal id={id} />, 'Deletar paciente', '32%')
    }

    return customers?.content?.map((item: CustomerModel) => {
      return {
        code: item?.cdCliente,
        name: item?.nome,
        cpf: maskCpf(item?.cpf),
        actions: (
          <div className="table-icons">
            <Link
              to={`/meus-pacientes/${item?.cdCliente}/dados-cadastrais`}
              title="Editar"
            >
              <IconEditSvg />
            </Link>
            <div
              className="delete-button"
              onClick={() => handleOpenDeleteModal(item.cdCliente)}
            >
              <IconTrashSvg />
            </div>
          </div>
        )
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customers?.content])

  const handleRemoveFilterCustomer = async () => {
    try {
      setFilterCustomerValues({ cpf: '', name: '' })

      const filterData = await filterCustomer({
        cpf: '',
        name: '',
        page: page
      }).load()

      setCustomers(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao remover filtro', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleFilterCustomer = async () => {
    try {
      const filterData = await filterCustomer({
        cpf: filterCustomerValues?.cpf || '',
        name: filterCustomerValues?.name || '',
        page: page
      }).load()

      setCustomers(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const me = await fetchMe().load()

        const data = await fetchListAll({ page: page }).load()
        setCustomers(data)
        console.log(data.totalElements)
        if (
          me?.cpf &&
          me?.usuario?.email &&
          me?.usuario?.nome &&
          me?.contato?.contato &&
          !data.totalElements &&
          setRunTuto
        ) {
          setRunTuto(true)
        }
      } catch (error) {
        console.error(error)
      }
    })()
  }, [page, refresh])

  return (
    <S.Wrapper className="my-clients">
      <S.Title>Meus pacientes</S.Title>
      <S.CardContainerWhite className="container">
        <S.ActionsContainer>
          <Button
            className="create-customer"
            initialIcon={<PlusSvg />}
            onClick={handleClickNewClientRegister}
          >
            Novo Cadastro
          </Button>
          <InputFilter
            name="filter"
            type="text"
            optionsToRadio={[
              { name: 'name', label: 'Nome' },
              { name: 'cpf', label: 'CPF' }
            ]}
            placeholder="Pesquisar"
            onFilter={handleFilterCustomer}
            onRemove={handleRemoveFilterCustomer}
            setFilterValues={setFilterCustomerValues}
            filterValues={filterCustomerValues}
          />
        </S.ActionsContainer>
        <S.TableContainer>
          {customers && customers?.content?.length > 0 ? (
            <Table
              onClick={handleRedirectToRegistrationData}
              columns={columns}
              dataTable={data}
              handlePageClick={(currentPage: any) =>
                setPage(currentPage.selected + 1)
              }
              pageCount={customers?.totalPages}
            />
          ) : customers?.empty ? (
            <EmptyData>Não há nenhum paciente para esse filtro</EmptyData>
          ) : (
            <EmptyData>Ainda não há pacientes</EmptyData>
          )}
        </S.TableContainer>
      </S.CardContainerWhite>
    </S.Wrapper>
  )
}
export default MyClients
